import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

export default function PartyAmnesty() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [idCard, setIdCard] = useState('');
  const [gender, setGender] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [ethnicity, setEthnicity] = useState('');
  const [address, setAddress] = useState('');
  const [debt, setDebt] = useState('');
  const [family, setFamily] = useState('');
  const [rename, setRename] = useState('');
  const [settle, setSettle] = useState('');
  const [blacklist, setBlacklist] = useState('');
  const [record, setRecord] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const [statusText, setStatusText] = useState('');

  useEffect(() => {
    api.get('/party-amnesty/status').then(({ data }) => {
      if (data.has_applied) {
        navigate('/household-registration', { replace: true });
      }
    }).catch(() => { });
  }, []);

  async function handleSubmit() {
    if (hasApplied || submitting) return;
    if (!name.trim() || !idCard.trim() || !gender || !ethnicity || !address.trim()) {
      toast.error('请填写姓名、证件号码、性别、民族和住址');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/party-amnesty', {
        name: name.trim(),
        id_number: idCard.trim(),
        gender,
        birth_date: birthDate.trim(),
        ethnicity,
        address: address.trim(),
        debt: debt.trim(),
        family: family.trim(),
        rename: rename.trim(),
        settlement: settle.trim(),
        blacklist: blacklist.trim(),
        criminal_record: record.trim(),
      });
      toast.success('提交成功');
      navigate('/household-registration', { replace: true });
    } catch (e: any) {
      toast.error(e?.response?.data?.message || '提交失败');
    } finally {
      setSubmitting(false);
    }
  }

  const birthDateRow = { icon: '/images/rudang_zhengjian.png', label: '出生日期' };

  const formRows = [
    { icon: '/images/rudang_xingming.png', label: '姓 名', placeholder: '请输入您的真实姓名', value: name, onChange: setName, required: true },
    { icon: '/images/rudang_zhengjian.png', label: '证 件', placeholder: '请输入证件号码', value: idCard, onChange: setIdCard, required: true },
    { icon: '/images/rudang_zhengjian.png', label: '住 址', placeholder: '请输入住址', value: address, onChange: setAddress, required: true },
    { icon: '/images/rudang_zhaiwu.png', label: '债 务', placeholder: '请输入债务情况（可选填）', value: debt, onChange: setDebt },
    { icon: '/images/rudang_jiating.png', label: '家 庭', placeholder: '请输入家庭情况（可选填）', value: family, onChange: setFamily },
    { icon: '/images/rudang_gengming.png', label: '更 名', placeholder: '请输入更名情况（可选填）', value: rename, onChange: setRename },
    { icon: '/images/rudang_luohu.png', label: '落 户', placeholder: '请输入落户情况（可选填）', value: settle, onChange: setSettle },
    { icon: '/images/rudang_heihu.png', label: '黑 户', placeholder: '请输入黑户情况（可选填）', value: blacklist, onChange: setBlacklist },
    { icon: '/images/rudang_xixni.png', label: '案 底', placeholder: '请输入案底情况（可选填）', value: record, onChange: setRecord },
  ];

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[#f5f5f5] pb-8"
      style={{
        backgroundImage: 'url(/images/rudang_beijing.png)',
        backgroundSize: '100%',
        backgroundPosition: 'top center',
      }}>
      <AuthGuard />

      {/* Hero Banner */}
      <div className="relative  pt-[160px]">
        <div
          className="w-full flex flex-col items-center justify-center"
        >
          <button
            onClick={() => navigate(-1)}
            className="absolute top-4 left-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/90 text-black/80"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
          </button>
        </div>
      </div>

      {/* Form Card */}
      <div className="mx-3 -mt-4 relative z-10 bg-white rounded-xl shadow-lg overflow-hidden mb-4 ">
        {/* Card Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <img src="/images/rudang_shenqing.png" alt="" className="w-5 h-5" />
            <span className="text-sm font-bold text-gray-800">申请信息填写</span>
          </div>
          <div className="flex items-center gap-1 text-[10px] text-[#b2a2a3]">
            <img src={"/images/rudang_xixni.png"} alt="rudang_xixni" className="w-3 h-3" />
            <span>信息加密传输，保障隐私安全</span>
          </div>
        </div>

        {/* Form Rows */}
        <div className="divide-y divide-gray-50">
          {formRows.map((row, i) => (
            <React.Fragment key={i}>
              <div className="flex items-center px-4 py-2 gap-3">
                <img src={row.icon} alt="" className="w-4 h-4 flex-shrink-0" />
                <span className="text-xs font-medium text-gray-700 w-12 flex-shrink-0">{row.label}</span>
                <input
                  type="text"
                  placeholder={row.placeholder}
                  value={row.value}
                  onChange={e => row.onChange(e.target.value)}
                  disabled={hasApplied}
                  className="flex-1 text-[11px] text-gray-800 placeholder-[#b2a2a3] outline-none bg-transparent disabled:opacity-60"
                />
                <img src="/images/rudang_jiantou.png" alt="" className="w-2 h-2 flex-shrink-0 opacity-30" />
              </div>
              {i === 1 && (
                <>
                  {/* 性别 */}
                  <div className="flex items-center px-4 py-2 gap-3">
                    <img src="/images/rudang_zhengjian.png" alt="" className="w-4 h-4 flex-shrink-0" />
                    <span className="text-xs font-medium text-gray-700 w-12 flex-shrink-0">性 别</span>
                    <select
                      value={gender}
                      onChange={e => setGender(e.target.value)}
                      disabled={hasApplied}
                      className="flex-1 text-[11px] text-gray-800 outline-none bg-transparent disabled:opacity-60"
                    >
                      <option value="">请选择性别</option>
                      <option value="男">男</option>
                      <option value="女">女</option>
                    </select>
                    <img src="/images/rudang_jiantou.png" alt="" className="w-2 h-2 flex-shrink-0 opacity-30" />
                  </div>
                  {/* 民族 */}
                  <div className="flex items-center px-4 py-2 gap-3">
                    <img src="/images/rudang_zhengjian.png" alt="" className="w-4 h-4 flex-shrink-0" />
                    <span className="text-xs font-medium text-gray-700 w-12 flex-shrink-0">民 族</span>
                    <select
                      value={ethnicity}
                      onChange={e => setEthnicity(e.target.value)}
                      disabled={hasApplied}
                      className="flex-1 text-[11px] text-gray-800 outline-none bg-transparent disabled:opacity-60"
                    >
                      <option value="">请选择民族</option>
                      {['汉族','蒙古族','回族','藏族','维吾尔族','苗族','彝族','壮族','布依族','朝鲜族','满族','侗族','瑶族','白族','土家族','哈尼族','哈萨克族','傣族','黎族','傈僳族','佤族','畲族','高山族','拉祜族','水族','东乡族','纳西族','景颇族','柯尔克孜族','土族','达斡尔族','仫佬族','羌族','布朗族','撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族','怒族','乌孜别克族','俄罗斯族','鄂温克族','德昂族','保安族','裕固族','京族','塔塔尔族','独龙族','鄂伦春族','赫哲族','门巴族','珞巴族','基诺族'].map(m => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                    <img src="/images/rudang_jiantou.png" alt="" className="w-2 h-2 flex-shrink-0 opacity-30" />
                  </div>
                  {/* 出生日期 */}
                  <div className="flex items-center px-4 py-2 gap-3">
                    <img src={birthDateRow.icon} alt="" className="w-4 h-4 flex-shrink-0" />
                    <span className="text-xs font-medium text-gray-700 w-12 flex-shrink-0">{birthDateRow.label}</span>
                    <input
                      type="date"
                      value={birthDate}
                      onChange={e => setBirthDate(e.target.value)}
                      disabled={hasApplied}
                      className="flex-1 text-[11px] text-gray-800 placeholder-[#b2a2a3] outline-none bg-transparent disabled:opacity-60"
                    />
                    <img src="/images/rudang_jiantou.png" alt="" className="w-2 h-2 flex-shrink-0 opacity-30" />
                  </div>
                </>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Submit Button */}
        <div className="px-4 py-4">
          {hasApplied ? (
            <div className="text-center py-3">
              <div className="inline-block bg-[#fdf8f2] text-[#c4161c] font-bold text-sm px-6 py-3 rounded-full">
                已提交申请（{statusText}）
              </div>
            </div>
          ) : (
            <button
              onClick={handleSubmit}
              disabled={submitting || !name.trim() || !idCard.trim() || !gender || !ethnicity || !address.trim()}
              className={`w-full transition ${(!name.trim() || !idCard.trim() || !gender || !ethnicity || !address.trim()) ? 'opacity-50' : ''}`}
            >
              <img src="/images/rudang_tijiao.png" alt="" className="w-full mx-auto" />
            </button>
          )}
        </div>


        {/* Benefit Icons */}
        <div className="flex flex-col gap-2">
          <img src="/images/rudang_quanyi.png" alt="" className="w-full mb-2" />
          <img src="/images/rudang_hefa.png" alt="" className="w-full mb-2" />
        </div>
      </div>
    </div>
  );
}
